export function isNodeList(el) {
  // Only NodeList has the "item()" function
  return typeof el.item !== "undefined";
}